module.exports = __webpack_public_path__ + "static/media/dumpster.d1d0e85a.svg";